<div class="richieste-container">
  <!-- Header della pagina -->
  <div class="richieste-header">
    <div class="title-container">
      <span class="material-icons" style="vertical-align: middle; margin-right: 8px; font-size: 28px; color: #166F72;">dashboard</span>
      <h1 class="page-title">{{ titoloRichieste }} <span *ngIf="!isEnteEsecutore && filtri.anno">{{ filtri.anno }}</span></h1>
     <!--  <span *ngIf="statoFiltro" class="filter-badge">{{ statoFiltro }}</span>
      <button *ngIf="filtriAttivi"
        pButton type="button" icon="pi pi-filter-slash"
        class="p-button-rounded p-button-text p-button-danger"
        (click)="azzeraTuttiFiltri()"
        pTooltip="Rimuovi tutti i filtri" tooltipPosition="top">
      </button> -->
    </div>

    <div class="actions-container">
      <!-- Area Ricerca e Filtri Inline - TUTTO SULLA STESSA RIGA -->
      <div class="search-and-filters-container" *ngIf="!isEnteEsecutore">
        <!-- Campo di ricerca -->
        <div class="custom-search-input">
          <i class="pi pi-search search-icon" [ngClass]="{'hidden': filtroTestoGlobale.length > 0}"></i>
          <input
            type="text"
            pInputText
            [(ngModel)]="filtroTestoGlobale"
            (input)="onFiltroGlobaleChange($event)"
            placeholder="Cerca richieste..."
            class="search-input"
            [ngClass]="{'has-text': filtroTestoGlobale.length > 0}"
            [disabled]="tabAttivaIndex === 1"
          />
          <i class="pi pi-times clear-icon" *ngIf="filtroTestoGlobale.length > 0" (click)="pulisciFiltroGlobale()" style="cursor: pointer;"></i>
        </div>

        <!-- Filtri sulla stessa riga -->
        <div class="inline-filters" *ngIf="!isEnteEsecutore">
          <!-- Filtro Anno -->
          <div class="filter-item anno-filter">
            <label class="filter-label">
              <i class="pi pi-calendar filter-icon"></i>
              Anno
            </label>
            <p-dropdown
              [options]="anniDisponibiliConRimuovi"
              [(ngModel)]="filtri.anno"
              [showClear]="false"
              placeholder="Tutti gli anni"
              styleClass="compact-dropdown anno-dropdown"
              appendTo="body"
              [filter]="false"
              [disabled]="tabAttivaIndex === 1"
              (onChange)="onAnnoChange($event)">
              <ng-template let-anno pTemplate="item">
                <div *ngIf="isAnnoValido(anno)" class="dropdown-item-badge-wrapper">
                  <span class="badge dropdown-item-badge"
                        [ngStyle]="{
                          'background-color': getAnnoColore(anno),
                          'color': '#ffffff',
                          'padding': '4px 8px',
                          'border-radius': '4px',
                          'font-weight': 'bold',
                          'display': 'block',
                          'text-align': 'left',
                          'width': 'fit-content',
                          'margin': '0',
                          'font-size': '0.85rem'
                        }">
                    {{ getAnnoValue(anno) }}
                  </span>
                </div>
                <div *ngIf="!isAnnoValido(anno)" class="reset-filter-option"
                     [ngStyle]="{
                       'font-style': 'italic',
                       'color': '#64748b',
                       'font-weight': '600',
                       'font-size': '0.75rem'
                     }">
                  <span style="font-style: italic; color: #64748b; font-weight: 600; font-size: 0.75rem;">{{ anno.anno || anno }}</span>
                </div>
              </ng-template>
              <ng-template let-anno pTemplate="selectedItem">
                <span *ngIf="isAnnoValido(anno)" class="badge selected-item-badge"
                      [ngStyle]="{
                        'background-color': getAnnoColore(anno),
                        'color': '#ffffff',
                        'padding': '2px 6px',
                        'border-radius': '3px',
                        'font-weight': 'bold',
                        'font-size': '0.7rem',
                        'text-align': 'left',
                        'margin': '0'
                      }">
                  {{ getAnnoValue(anno) }}
                </span>
                <span *ngIf="!anno || !isAnnoValido(anno)" style="color: #64748b; font-size: 0.875rem;">
                  Tutti gli anni
                </span>
              </ng-template>
            </p-dropdown>
          </div>

          <!-- Filtro Stato (solo per non ENTE_ESECUTORE) -->
          <div class="filter-item stato-filter" *ngIf="!isEnteEsecutore">
            <label class="filter-label">
              <i class="pi pi-flag filter-icon"></i>
              Stato
            </label>
            <p-dropdown
              [options]="statiConRimuovi"
              [(ngModel)]="filtri.stato"
              optionLabel="label"
              optionValue="value"
              placeholder="Tutti gli stati"
              [showClear]="false"
              [filter]="false"
              styleClass="compact-dropdown stato-dropdown"
              appendTo="body"
              [disabled]="tabAttivaIndex === 1"
              (onChange)="onStatoChange($event)">
              <ng-template let-stato pTemplate="item">
                <div *ngIf="isStatoValido(stato)" style="font-size: 0.75rem;">
                  {{ stato.label }}
                </div>
                <div *ngIf="!isStatoValido(stato)" class="reset-filter-option"
                     [ngStyle]="{
                       'font-style': 'italic',
                       'color': '#64748b',
                       'font-weight': '600',
                       'font-size': '0.75rem'
                     }">
                  <span style="font-style: italic; color: #64748b; font-weight: 600; font-size: 0.75rem;">{{ stato.label }}</span>
                </div>
              </ng-template>
              <ng-template let-stato pTemplate="selectedItem">
                <span *ngIf="stato && isStatoValido(stato)">
                  {{ stato.label }}
                </span>
                <span *ngIf="!stato || !isStatoValido(stato)" style="color: #64748b; font-size: 0.875rem;">
                  Tutti gli stati
                </span>
              </ng-template>
            </p-dropdown>
          </div>

          <!-- Reset Filtri -->
          <button
            *ngIf="filtriAttivi"
            pButton
            type="button"
            icon="pi pi-filter-slash"
            class="p-button-rounded p-button-text p-button-sm reset-filters-btn"
            [disabled]="tabAttivaIndex === 1"
            (click)="azzeraTuttiFiltri()"
            pTooltip="Rimuovi tutti i filtri"
            tooltipPosition="top">
          </button>
        </div>
      </div>

      <!-- Container per i pulsanti di azione -->
      <div class="action-buttons-container">
        <!-- Bottone semplice per ENTE_ESECUTORE -->
        <button *ngIf="isEnteEsecutore" class="action-button" (click)="scaricaReportRichieste()"
                style="background-color: #C7CEEA; color: #333; border: 1px solid #B2BCDC; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px;">
          <span class="pi pi-cloud-download" style="margin-right: 6px; font-size: 15px;"></span>
          Report
        </button>

        <!-- Bottone con menu dropdown per gli altri utenti -->
        <button *ngIf="!isEnteEsecutore" class="action-button" (click)="apriMenuReport($event)"
                style="background-color: #C7CEEA; color: #333; border: 1px solid #B2BCDC; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px; position: relative;">
          <span class="pi pi-cloud-download" style="margin-right: 6px; font-size: 15px;"></span>
          Report
          <span class="pi pi-angle-down" style="margin-left: 4px; font-size: 12px;"></span>
        </button>
      <!--   <button *ngIf="!this.isEnteEsecutore" class="action-button" (click)="scaricaReportATORichieste()"
                style="background-color: #163868; color: #fffbfb; border: 1px solid #B2BCDC; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px;">
          <span class="material-symbols-outlined" style="margin-right: 8px; font-size: 20px;">assessment</span>
          Report ATO
        </button> -->

        <button class="action-button" (click)="aggiornaRichieste()"
                style="background-color: #F8E9A1; color: #333; border: 1px solid #EBDC8D; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px;">
          <span class="pi pi-refresh" style="margin-right: 6px; font-size: 15px;"></span>
          Aggiorna
        </button>
        <button *ngIf="!isEnteEsecutore" class="action-button" (click)="assegnaMassivamenteDetermine()"
        style="background-color: #8bb9d2; color: #333; border: 1px solid #B2BCDC; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px;"
        pTooltip="Assegna determine in blocco" tooltipPosition="top">
        <span class="material-icons" style="margin-right: 6px; font-size: 15px;">select_all</span>
          Determine
      </button>
        <button *ngIf="!isEnteEsecutore && !richiesteAnnoSuccessivoSonoPresenti && annoCorrente === annoAttualeReale" class="action-button"
            style="background-color: #a0cccc; color: #333; border: 1px solid #A0D6C1; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px;"
                (click)="generaRichieste()" pTooltip="Genera richieste per l'anno {{ annoCorrente + 1 }}">
              <span class="material-icons" style="margin-right: 6px; font-size: 15px;">add</span>
              Genera
        </button>
      </div>
    </div>
  </div>

  <!-- Contenuto principale -->
  <div class="richieste-content">
    <!-- TabView per ente esecutore o admin/umvs (tabella + storico) -->
    <p-tabView *ngIf="isEnteEsecutore || isAdminOrUmvs" styleClass="richieste-tabview" [(activeIndex)]="tabAttivaIndex" (onChange)="onTabChange($event)">
      <!-- Tab 1: Tabella Richieste -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span class="material-icons" style="vertical-align: middle; margin-right: 6px; font-size: 18px;">table_chart</span>
          <span>Richieste</span>
        </ng-template>

        <!-- Loader mentre vengono caricate le richieste -->
        <div *ngIf="!richiesteCaricate" class="loading-container">
          <div class="spinner"></div>
          <p>Caricamento richieste in corso...</p>
        </div>

        <!-- Lista delle richieste con p-table -->
        <div *ngIf="richiesteCaricate" class="richieste-list">
      <!-- Messaggio se non ci sono richieste -->
      <div *ngIf="richieste.length === 0" class="empty-state">
        <span class="material-icons">search_off</span>
        <h3>Nessuna richiesta trovata</h3>
       <!--  <p>Non ci sono richieste che corrispondono ai filtri selezionati.</p> -->
      </div>

      <!-- PrimeNG Table -->
      <p-table
        *ngIf="richieste.length > 0"
        #dt
        [value]="richieste"
        [columns]="cols"
        [paginator]="true"
        [rows]="30"
        [rowsPerPageOptions]="[30,100,200]"
        styleClass="p-datatable-sm p-datatable-gridlines"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Richieste da {first} a {last} di {totalRecords}"
        [globalFilterFields]="['anno', 'enteEsecutore.label', 'enteEsecutore.categoria.descrizione', 'stato.descrizione', 'importoRichiesto', 'importoContributo', 'importoFinanziato', 'importoRendicontato', 'importoLiquidato']"
        [sortMode]="'multiple'"
        [multiSortMeta]="[{field: 'richiesta.anno', order: -1}, {field: 'enteEsecutore.label', order: 1}]"
        [showInitialSortBadge]="false"
        [responsiveLayout]="'scroll'"
        [rowHover]="true"
        [loading]="!richiesteCaricate"
        [style]="{'margin-bottom': '20px'}">

        <!-- Intestazioni delle colonne -->
        <ng-template pTemplate="header">
          <tr>
            <th  style="width: 2%; text-align: center;">Azioni</th>
            <th *ngFor="let col of cols"
              [pSortableColumn]="col.sortable ? col.field : null"
              [style.width]="col.width"
              [ngStyle]="{
                  'text-align': col.field === 'anno'
                  || col.field === 'tipoEnte'
                  || col.field === 'stato'
                  || col.field === 'importoRichiesto'
                  || col.field === 'importoContributo'
                  || col.field === 'importoRimodulato'
                  || col.field === 'importoFinanziato'
                  || col.field === 'importoRendicontato'
                  || col.field === 'importoLiquidato'
                  || col.field === 'presentata'
                  || col.field === 'finanziata' ? 'center' : 'left',
                  'font-size': '12px'
                  }">
              {{ col.header }}
              <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <!-- Corpo della tabella -->
        <ng-template pTemplate="body" let-richiesta>
          <tr>
            <td class="text-center" style="width: 10px;">
              <button
                pButton type="button" style="color:rgb(39, 128, 15)"
                icon="pi pi-ellipsis-v " class="p-button-rounded p-button-text small-icon"
                (click)="openCaricaAzioni($event,richiesta)"
                >
              </button>
            </td>
              <td>
                <span class="badge"
                      [ngStyle]="{
                        'background-color': stiliService.getColoreAnnoRichiesta(richiesta),
                        'color': '#ffffff',
                        'padding': '4px 8px',
                        'border-radius': '4px',
                        'font-weight': 'bold',
                        'display': 'block',
                        'text-align': 'center',
                        'width': 'fit-content',
                        'margin': '0 auto'
                      }" pTooltip="{{ richiesta.note }}" tooltipPosition="top">
                  {{ richiesta.anno }}
                </span>
              </td>
              <td class="text-center">
                <span
                  class="material-symbols-outlined small-icon"
                  style="display: flex; justify-content: center; align-items: center;"
                  [ngClass]="stiliService.getMaterialIconEnteEsecutore(richiesta.enteEsecutore)"
                  [ngStyle]="{
                    'color': stiliService.getColoreIconaEnteEsecutore(richiesta.enteEsecutore)
                  }"
                  [pTooltip]="richiesta.enteEsecutore.categoria.descrizione | uppercase" tooltipPosition="top">
                  {{ stiliService.getMaterialIconEnteEsecutore(richiesta.enteEsecutore) }}
                </span>
              </td>
               <!--  {{ richiesta.enteEsecutore.categoria.codice }} -->

              <td>
                <span style="display: block; text-align: left; font-size: 11.5px;"> {{ richiesta.enteEsecutore.label }}</span>
              </td>
              <td>
                <span
                class="material-symbols-outlined small-icon"
                style="display: flex; justify-content: center; align-items: center;"
                [ngClass]="stiliService.getMaterialIconStatoRichiesta(richiesta)"
                [ngStyle]="{
                  'color': stiliService.getColoreIconaStatoRichiesta(richiesta)
                }"
                [pTooltip]="richiesta.stato.descrizione | uppercase" tooltipPosition="top">
                {{ stiliService.getMaterialIconStatoRichiesta(richiesta) }}
              </span>
              <!--   {{ richiesta.stato.descrizione }} -->
              </td>
              <td class="text-center">
                <div *ngIf="richiesta.importoRichiesto" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #FFF8DC; border: 1px solid #c7cd22;">
                  <span class="chip-label">{{ richiesta.importoRichiesto ? (richiesta.importoRichiesto | currency:'EUR':'':'1.2-2':'it-IT') : '-' }}</span>
                  <i class="pi pi-euro" style="font-size: 14px; color: #c7cd22; margin-left: 6px;"></i>
                </div>
              </td>
              <td class="text-center">
                <div *ngIf="richiesta.importoContributo" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #e6faf5; border: 1px solid #4f97c4;">
                  <span class="chip-label">{{ richiesta.importoContributo ? (richiesta.importoContributo | currency:'EUR':'':'1.2-2':'it-IT') : '-' }}</span>
                  <i class="pi pi-euro" style="font-size: 14px; color: #4f97c4; margin-left: 6px;"></i>
                </div>
              </td>
              <td class="text-center">
                <div *ngIf="richiesta.importoRimodulato" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #E8F5E9; border: 2px solid #81C784;">
                  <span class="chip-label" style="color: #2E7D32;">{{ richiesta.importoRimodulato ? (richiesta.importoRimodulato | currency:'EUR':'':'1.2-2':'it-IT') : '-' }}</span>
                  <i class="pi pi-euro" style="font-size: 14px; color: #2E7D32; margin-left: 6px;"></i>
                </div>
              </td>
              <td class="text-center">
                <div *ngIf="richiesta.importoFinanziato" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #dbfaec; border: 1px solid #57e3b9;">
                  <span class="chip-label">{{ richiesta.importoFinanziato ? (richiesta.importoFinanziato | currency:'EUR':'':'1.2-2':'it-IT') : '-' }}</span>
                  <i class="pi pi-euro" style="font-size: 14px; color: #57e3b9; margin-left: 6px;"></i>
                </div>
              </td>
              <td class="text-center">
                <div *ngIf="richiesta.importoRendicontato" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #dcefff; border: 1px solid #1f1f72;">
                  <span class="chip-label">{{ richiesta.importoRendicontato ? (richiesta.importoRendicontato | currency:'EUR':'':'1.2-2':'it-IT') : '-' }}</span>
                  <i class="pi pi-euro" style="font-size: 14px; color: #1f1f72; margin-left: 6px;"></i>
                </div>
              </td>
              <td class="text-center">
                <div *ngIf="richiesta.importoLiquidato" class="custom-chip pmo-importo-liquidato-chip">
                  <span class="chip-label">{{ richiesta.importoLiquidato ? (richiesta.importoLiquidato | currency:'EUR':'':'1.2-2':'it-IT') : '-' }}</span>
                  <i class="pi pi-euro" style="font-size: 14px; margin-left: 6px;"></i>
                </div>
              </td>
              <td>
                <span style="font-weight: semi-bold; display: block; text-align: center; font-size: 12px;" pTooltip="Richiesta presentata alle ore {{ richiesta.presentata | date:'HH:mm' }} del {{ richiesta.presentata | date:'dd/MM/yyyy' }}" pTooltipPosition="top">{{ richiesta.presentata | date:'dd/MM/yyyy' }}</span>
              </td>
              <td>
                <span style="font-weight: semi-bold; display: block; text-align: center; font-size: 12px;">{{ richiesta.finanziata | date:'dd/MM/yyyy' }}</span>
              </td>

          </tr>
          <!-- <tr [ngClass]="'stato-' + richiesta.stato">
            <td *ngFor="let col of cols">
              <span class="p-column-title">{{ col.header }}</span>
              <ng-container *ngIf="col.field !== 'stato' && col.field !== 'importo' && col.field !== 'dataCreazione'">
                {{ richiesta[col.field] }}
              </ng-container>

              <ng-container *ngIf="col.field === 'importo'">
                {{ richiesta.importo | currency:'EUR' }}
              </ng-container>

              <ng-container *ngIf="col.field === 'dataCreazione'">
                {{ richiesta.dataCreazione | date:'dd/MM/yyyy' }}
              </ng-container>

              <ng-container *ngIf="col.field === 'stato'">
                <p-tag
                  [value]="richiesta.stato"
                  [severity]="getStatoSeverity(richiesta.stato)"
                ></p-tag>
              </ng-container>
            </td>

            <td>
              <div class="p-d-flex p-jc-center">
                <button pButton icon="pi pi-eye" class="p-button-rounded p-button-text p-button-info"
                  title="Visualizza dettagli"></button>
                <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-success"
                  title="Modifica richiesta"></button>
                <button pButton icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger"
                  title="Elimina richiesta" (click)="eliminaRichiesta(richiesta)"></button>
              </div>
            </td>
          </tr> -->
        </ng-template>

        <!-- Footer della tabella -->
        <ng-template pTemplate="paginatorleft">
          <!-- Bottone di refresh spostato in alto -->
        </ng-template>

        <ng-template pTemplate="paginatorright">
          <!-- Rimosso il pulsante di download che è stato spostato sopra -->
        </ng-template>

        <!-- Footer della tabella con le somme -->
        <ng-template pTemplate="footer">
          <tr style="background-color: #f8f9fa; border-top: 2px solid #dee2e6;">
            <td colspan="5" style="text-align: right; font-weight: 600; font-size: 14px; padding: 15px 10px;">TOTALI:</td>
            <td class="text-center" style="padding: 15px 10px;">
              <div *ngIf="getTotaleImportoRichiesto()" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #FFF8DC; border: 2px solid #c7cd22; padding: 8px 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                <span class="chip-label" style="font-size: 14px; font-weight: 600; color: #333;">{{ getTotaleImportoRichiesto() | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                <i class="pi pi-euro" style="font-size: 14px; color: #c7cd22; margin-left: 8px;"></i>
              </div>
            </td>
            <td class="text-center" style="padding: 15px 10px;">
              <div *ngIf="getTotaleImportoContributo()" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #e6faf5; border: 2px solid #4f97c4; padding: 8px 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                <span class="chip-label" style="font-size: 14px; font-weight: 600; color: #333;">{{ getTotaleImportoContributo() | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                <i class="pi pi-euro" style="font-size: 14px; color: #4f97c4; margin-left: 8px;"></i>
              </div>
            </td>
            <td class="text-center" style="padding: 15px 10px;">
              <div *ngIf="getTotaleImportoRimodulato()" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #E8F5E9; border: 2px solid #81C784; padding: 8px 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                <span class="chip-label" style="font-size: 14px; font-weight: 600; color: #2E7D32;">{{ getTotaleImportoRimodulato() | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                <i class="pi pi-euro" style="font-size: 14px; color: #2E7D32; margin-left: 8px;"></i>
              </div>
            </td>
            <td class="text-center" style="padding: 15px 10px;">
              <div *ngIf="getTotaleImportoFinanziato()" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #dbfaec; border: 2px solid #57e3b9; padding: 8px 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                <span class="chip-label" style="font-size: 14px; font-weight: 600; color: #333;">{{ getTotaleImportoFinanziato() | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                <i class="pi pi-euro" style="font-size: 14px; color: #57e3b9; margin-left: 8px;"></i>
              </div>
            </td>
            <td class="text-center" style="padding: 15px 10px;">
              <div *ngIf="getTotaleImportoRendicontato()" class="custom-chip" style="display: flex; margin: 0 auto; width: fit-content; background-color: #dcefff; border: 2px solid #1f1f72; padding: 8px 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                <span class="chip-label" style="font-size: 14px; font-weight: 600; color: #333;">{{ getTotaleImportoRendicontato() | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                <i class="pi pi-euro" style="font-size: 14px; color: #1f1f72; margin-left: 8px;"></i>
              </div>
            </td>
            <td class="text-center" style="padding: 15px 10px;">
              <div class="custom-chip pmo-importo-liquidato-chip pmo-importo-liquidato-chip--totale">
                <span class="chip-label">{{ getTotaleImportoLiquidato() | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                <i class="pi pi-euro" style="font-size: 14px; margin-left: 8px;"></i>
              </div>
            </td>
            <td colspan="2"></td>
          </tr>
        </ng-template>
      </p-table>
      <div *ngIf="isDownloading" class="loading-overlay" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255,255,255,0.9); display: flex; justify-content: center; align-items: center; z-index: 1000;">
        <ng-lottie [options]="options" width="300px" height="300px"></ng-lottie>
      </div>
        </div>
      </p-tabPanel>

      <!-- Tab 2: Storico Grafico -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span class="material-icons" style="vertical-align: middle; margin-right: 6px; font-size: 18px;">show_chart</span>
          <span>Storico</span>
        </ng-template>

        <!-- Filtro ente per lo storico (solo per utenti NON ente esecutore) -->
        <div *ngIf="!isEnteEsecutore && isAdminOrUmvs" class="storico-filter-container" style="margin-top: 20px; margin-bottom: 20px; padding: 15px; background-color: #f8f9fa; border-radius: 8px; border: 1px solid #e2e8f0;">
          <div class="filter-item" style="display: flex; align-items: center; gap: 12px;">
            <label class="filter-label" style="display: flex; align-items: center; gap: 8px; font-weight: 600; color: #3a6e75; font-size: 14px; white-space: nowrap;">
              <i class="pi pi-filter filter-icon" style="font-size: 16px;"></i>
              Filtra per ente:
            </label>
            <p-dropdown
              [options]="entiEsecutoriConTutti"
              [(ngModel)]="enteStoricoSelezionatoPerDropdown"
              optionLabel="label"
              [placeholder]="'Tutti gli enti'"
              [showClear]="false"
              styleClass="compact-dropdown storico-ente-dropdown"
              appendTo="body"
              [filter]="true"
              filterBy="label"
              [style]="{'min-width': '300px'}"
              (onChange)="onEnteStoricoChange($event)">
              <ng-template let-ente pTemplate="item">
                <div *ngIf="ente.id === -1" style="display: flex; align-items: center; gap: 8px; font-style: italic; color: #64748b;">
                  <i class="pi pi-filter-slash" style="font-size: 16px;"></i>
                  <span style="font-size: 13px;">{{ ente.label }}</span>
                </div>
                <div *ngIf="ente.id !== -1" style="display: flex; align-items: center; gap: 8px;">
                  <span
                    class="material-symbols-outlined"
                    style="font-size: 18px;"
                    [ngClass]="stiliService.getMaterialIconEnteEsecutore(ente)"
                    [ngStyle]="{
                      'color': stiliService.getColoreIconaEnteEsecutore(ente)
                    }">
                    {{ stiliService.getMaterialIconEnteEsecutore(ente) }}
                  </span>
                  <span style="font-size: 13px;">{{ ente.label }}</span>
                </div>
              </ng-template>
              <ng-template let-ente pTemplate="selectedItem">
                <div *ngIf="ente && ente.id === -1" style="display: flex; align-items: center; gap: 8px; font-style: italic; color: #64748b;">
                  <i class="pi pi-filter-slash" style="font-size: 16px;"></i>
                  <span style="font-size: 13px;">{{ ente.label }}</span>
                </div>
                <div *ngIf="ente && ente.id !== -1" style="display: flex; align-items: center; gap: 8px;">
                  <span
                    class="material-symbols-outlined"
                    style="font-size: 18px;"
                    [ngClass]="stiliService.getMaterialIconEnteEsecutore(ente)"
                    [ngStyle]="{
                      'color': stiliService.getColoreIconaEnteEsecutore(ente)
                    }">
                    {{ stiliService.getMaterialIconEnteEsecutore(ente) }}
                  </span>
                  <span style="font-size: 13px; font-weight: 500;">{{ ente.label }}</span>
                </div>
                <span *ngIf="!ente" style="color: #64748b; font-size: 13px;">Tutti gli enti</span>
              </ng-template>
            </p-dropdown>
          </div>
        </div>

        <div class="storico-chart-container" *ngIf="storicoCaricato">
          <div class="chart-wrapper" *ngIf="chartData && chartData.labels && chartData.labels.length > 0">
            <p-chart type="bar" [data]="chartData" [options]="chartOptions"></p-chart>
          </div>
          <div *ngIf="!chartData || !chartData.labels || chartData.labels.length === 0" class="chart-empty-state">
            <span class="material-icons">bar_chart</span>
            <p>Nessun dato storico disponibile</p>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>



  <!-- Dialog per lo storico -->
  <!-- <p-dialog
    [(visible)]="mostraStorico"
    [modal]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{width: '50%', maxWidth: '1000px'}"
    [contentStyle]="{overflow: 'auto'}"
    styleClass="storico-dialog">

    <ng-template pTemplate="header">
      <span [innerHTML]="titoloStorico"></span>
    </ng-template>



    <ng-template pTemplate="footer">
      <button pButton pRipple label="Chiudi" icon="pi pi-times"
              class="p-button-secondary"
              (click)="mostraStorico = false"></button>
    </ng-template>
  </p-dialog> -->

  <!-- Toast per notifiche -->
  <p-toast position="top-right"></p-toast>
  <p-tieredMenu #menuAzioniTiered [popup]="true" [model]="menuAzioniItems"></p-tieredMenu>
  <p-menu #menuReport [model]="menuReportItems" [popup]="true"></p-menu>
  <app-storico [richiestaId]="richiestaIdStorico" ></app-storico>
  <app-storico-contributi></app-storico-contributi>
  <!-- Componente ComunicaContributo -->
  <app-comunica-contributo
    [(visible)]="mostraComunicaContributo"
    [richiesta]="richiestaSelezionata"
    (confermato)="onConfermaComunicaContributo($event)">
  </app-comunica-contributo>

  <!-- Aggiungo il componente per caricare la lettera -->
  <app-carica-lettera
    [(visible)]="mostraCaricaLettera"
    [richiesta]="richiestaSelezionata"
    (uploadCompletato)="onUploadLetteraCompletato($event)">
  </app-carica-lettera>

  <!-- Aggiungo il componente per generare le richieste -->
  <app-genera-richieste
    [(visible)]="mostraGeneraRichieste"
    [anno]="annoCorrente"
    (richiesteGenerate)="onRichiesteGenerate($event)">
  </app-genera-richieste>

  <!-- Aggiungo il componente per la conferma di eliminazione -->
  <app-conferma-eliminazione
    [(visible)]="mostraConfermaEliminazione"
    [richiesta]="richiestaSelezionata"
    (eliminazioneConfermata)="onEliminazioneConfermata($event)">
  </app-conferma-eliminazione>

  <!-- Aggiungo il componente per la dichiarazione pronta -->
  <app-chiudi-preparazione-richiesta
    [richiesta]="richiestaSelezionata"
    (finePreparazione)="onDichiarazionePronta()">
  </app-chiudi-preparazione-richiesta>

  <!-- Aggiungo il componente per la modifica della richiesta -->
  <app-modifica-richiesta
    [(visible)]="mostraModificaRichiesta"
    [richiesta]="richiestaSelezionata"
    (modificaCompletata)="onModificaCompletata()">
  </app-modifica-richiesta>

  <!-- Aggiungo il componente per la conferma del finanziamento -->
  <app-conferma-finanziamento
    [(visible)]="mostraConfermaFinanziamento"
    [richiesta]="richiestaSelezionata"
    (finanziamentoConfermato)="onFinanziamentoConfermato()">
  </app-conferma-finanziamento>

  <!-- Aggiungo il componente per la creazione della variante -->
  <app-variante
    [(visible)]="mostraVariante"
    [richiesta]="richiestaSelezionata"
    (varianteCreata)="onVarianteCreata()">
  </app-variante>

  <!-- Componente per assegnazione massiva determine -->
  <app-assegna-massivamente-determine
    [(visible)]="mostraAssegnaMassivamenteDetermine"
    [richiestaPreselezionata]="richiestaSelezionata"
    (determineAssegnate)="onDetermineAssegnate()">
  </app-assegna-massivamente-determine>

  <!-- Modale Report Regione - Annuale -->
  <p-dialog
    [(visible)]="mostraReportAnnuale"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closeOnEscape]="true"
    [dismissableMask]="true"
    [style]="{width: '500px'}"
    styleClass="p-fluid report-regione-dialog"
    [showHeader]="false"
    (onHide)="annullaReportAnnuale()">

    <div class="dialog-container">
      <div class="dialog-header">
        <div class="header-content">
          <i class="pi pi-calendar header-icon" style="color: #166F72;"></i>
          <h2>Report Regione - Annuale</h2>
        </div>
        <button
          pButton
          pRipple
          icon="pi pi-times"
          class="p-button-rounded p-button-text close-btn"
          (click)="annullaReportAnnuale()">
        </button>
      </div>

      <div class="dialog-content">
        <div class="field">
          <label for="annoReport" class="field-label">
            <i class="pi pi-calendar field-icon"></i>
            Seleziona l'anno
          </label>
          <p-dropdown
            id="annoReport"
            [options]="anniDisponibili"
            [(ngModel)]="annoReportSelezionato"
            placeholder="Seleziona un anno"
            styleClass="report-dropdown"
            appendTo="body"
            [filter]="false">
            <ng-template let-anno pTemplate="item">
              <div class="dropdown-item-badge-wrapper">
                <span class="badge dropdown-item-badge"
                      [ngStyle]="{
                        'background-color': getAnnoColore(anno),
                        'color': '#ffffff',
                        'padding': '4px 8px',
                        'border-radius': '4px',
                        'font-weight': 'bold',
                        'display': 'block',
                        'text-align': 'left',
                        'width': 'fit-content',
                        'margin': '0',
                        'font-size': '0.9rem'
                      }">
                  {{ anno }}
                </span>
              </div>
            </ng-template>
            <ng-template let-anno pTemplate="selectedItem">
              <span class="badge selected-item-badge"
                    [ngStyle]="{
                      'background-color': getAnnoColore(anno),
                      'color': '#ffffff',
                      'padding': '4px 8px',
                      'border-radius': '4px',
                      'font-weight': 'bold',
                      'font-size': '0.9rem'
                    }">
                {{ anno }}
              </span>
            </ng-template>
          </p-dropdown>
        </div>

        <div class="info-box">
          <i class="pi pi-info-circle"></i>
          <span>Il report verrà generato per l'anno selezionato</span>
        </div>
      </div>

      <div class="dialog-footer">
        <button
          pButton
          pRipple
          label="Annulla"
          icon="pi pi-times"
          class="p-button-outlined p-button-secondary"
          (click)="annullaReportAnnuale()">
        </button>
        <button
          pButton
          pRipple
          label="Genera Report"
          icon="pi pi-file-excel"
          class="p-button-success"
          (click)="confermaReportAnnuale()">
        </button>
      </div>
    </div>
  </p-dialog>

  <!-- Modale Report Regione - Mensile -->
  <p-dialog
    [(visible)]="mostraReportMensile"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closeOnEscape]="true"
    [dismissableMask]="true"
    [style]="{width: '500px'}"
    styleClass="p-fluid report-regione-dialog"
    [showHeader]="false"
    (onHide)="annullaReportMensile()">

    <div class="dialog-container">
      <div class="dialog-header">
        <div class="header-content">
          <i class="pi pi-calendar-times header-icon" style="color: #166F72;"></i>
          <h2>Report Regione - Mensile</h2>
        </div>
        <button
          pButton
          pRipple
          icon="pi pi-times"
          class="p-button-rounded p-button-text close-btn"
          (click)="annullaReportMensile()">
        </button>
      </div>

      <div class="dialog-content">
        <div class="field">
          <label for="annoReportMensile" class="field-label">
            <i class="pi pi-calendar field-icon"></i>
            Seleziona l'anno
          </label>
          <p-dropdown
            id="annoReportMensile"
            [options]="anniDisponibili"
            [(ngModel)]="annoReportSelezionato"
            placeholder="Seleziona un anno"
            styleClass="report-dropdown"
            appendTo="body"
            [filter]="false">
            <ng-template let-anno pTemplate="item">
              <div class="dropdown-item-badge-wrapper">
                <span class="badge dropdown-item-badge"
                      [ngStyle]="{
                        'background-color': getAnnoColore(anno),
                        'color': '#ffffff',
                        'padding': '4px 8px',
                        'border-radius': '4px',
                        'font-weight': 'bold',
                        'display': 'block',
                        'text-align': 'left',
                        'width': 'fit-content',
                        'margin': '0',
                        'font-size': '0.9rem'
                      }">
                  {{ anno }}
                </span>
              </div>
            </ng-template>
            <ng-template let-anno pTemplate="selectedItem">
              <span class="badge selected-item-badge"
                    [ngStyle]="{
                      'background-color': getAnnoColore(anno),
                      'color': '#ffffff',
                      'padding': '4px 8px',
                      'border-radius': '4px',
                      'font-weight': 'bold',
                      'font-size': '0.9rem'
                    }">
                {{ anno }}
              </span>
            </ng-template>
          </p-dropdown>
        </div>

        <div class="field">
          <label for="meseReport" class="field-label">
            <i class="pi pi-calendar-times field-icon"></i>
            Seleziona il mese
          </label>
          <p-dropdown
            id="meseReport"
            [options]="mesiDisponibili"
            [(ngModel)]="meseReportSelezionato"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleziona un mese"
            styleClass="report-dropdown"
            appendTo="body"
            [filter]="false">
          </p-dropdown>
        </div>

        <div class="info-box">
          <i class="pi pi-info-circle"></i>
          <span>Il report verrà generato per il periodo selezionato</span>
        </div>
      </div>

      <div class="dialog-footer">
        <button
          pButton
          pRipple
          label="Annulla"
          icon="pi pi-times"
          class="p-button-outlined p-button-secondary"
          (click)="annullaReportMensile()">
        </button>
        <button
          pButton
          pRipple
          label="Genera Report"
          icon="pi pi-file-excel"
          class="p-button-success"
          (click)="confermaReportMensile()">
        </button>
      </div>
    </div>
  </p-dialog>

</div>
